import {
	Button,
	ButtonProps,
	ButtonVariant,
	ElementProps,
	MantineColor,
} from "@mantine/core";

import classes from "./CampaignButton.module.scss";

export interface CampaignButtonProps
	extends Omit<ButtonProps, "variant" | "color">,
		ElementProps<"button", keyof ButtonProps> {
	variant?: ButtonVariant;
	color?: MantineColor;
	active?: boolean;
}

export default function CampaignButton({
	color = "#433931",
	variant = "outline",
	active,
	...props
}: CampaignButtonProps) {
	return (
		<Button
			radius="0"
			variant={variant}
			color={color}
			data-active={active || undefined}
			classNames={{ root: classes.root }}
			{...props}
		></Button>
	);
}
